import { AdvanceShareStyleAiAspectRatioList, AdvanceShareStyleAiProviderList, AdvanceShareStyleRenderingConfigDefinition } from '@/models/advance-share-style-definition.model';
import React from 'react';
import {
  Panel,
  Form,
  SelectPicker,
  Grid,
  Row,
  Col,
} from 'rsuite';

interface RenderingConfigDefinitionPanelProps {
  value: AdvanceShareStyleRenderingConfigDefinition | undefined;
  onChange: (next: AdvanceShareStyleRenderingConfigDefinition) => void;
  disabled?: boolean;
}

const RenderingConfigDefinitionPanel: React.FC<RenderingConfigDefinitionPanelProps> = ({value, onChange, disabled }) => {

  return (
    <>
      <Panel
        header={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Rendering Configs</span>
          </div>
        }
        bordered
      >
        <Grid w='100%' fluid >
          <Row>
            <Col span={{xs:24, xl:12}} >
              <Form.Group controlId="defaultAspectRatio">
                <Form.Label>Default Aspect Ratio</Form.Label>
                {/*
                  A plain SelectPicker rather than a Form.Control: these two fields
                  live under `renderingConfig`, not at the top level of the parent
                  form's value, so a name-based binding never finds them and the
                  picker renders empty however the version was saved. The sibling
                  panels get away with Form.Control because each drives its own
                  nested form over a flat object.
                */}
                <SelectPicker
                  block
                  data={AdvanceShareStyleAiAspectRatioList}
                  disabled={disabled}
                  value={value?.defaultAspectRatio ?? null}
                  onChange={val => onChange({...value, defaultAspectRatio: val ?? undefined})}
                  />
              </Form.Group>
            </Col>
            <Col span={{xs:24, xl:12}} >
              <Form.Group controlId="preferredAiProvider">
                <Form.Label>Preferred AI Provider</Form.Label>
                <SelectPicker
                  block
                  data={AdvanceShareStyleAiProviderList}
                  disabled={disabled}
                  value={value?.preferredAiProvider ?? null}
                  onChange={val => onChange({...value, preferredAiProvider: val ?? undefined})}
                />
              </Form.Group>
            </Col>
          </Row>
        </Grid>
      </Panel>
    </>
  );
};

export default RenderingConfigDefinitionPanel;
